import React from "react";
import styles from "./PageContainer.module.css";

const PageContainer = ({ children, className = "" }) => {
	return (
		<div className={`${styles.pageContainer} ${className}`}>
			<div className={styles.contentWrapper}>{children}</div>
		</div>
	);
};

export default PageContainer;
